export default __webpack_public_path__ + "static/media/DUSK-BNB.e69c7d6c.svg";